import {
  AtSign,
  CalendarDays,
  ChartColumn,
  Handshake,
  History,
  House,
  Image,
  Inbox,
  Megaphone,
  Settings,
  ShoppingBag,
  Ticket,
  Users,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  /** Path prefixes this item owns, the old pages it replaces included, so
   *  /drafts lights up 검토 while it still lives at its old address. */
  match: string[]
  /** 0 = the day's work, 1 = programmes, 2 = the setup behind them. */
  group: 0 | 1 | 2
  /** Shows the pending-review count. */
  badge?: 'review'
}

/** The sidebar, in order (plan 1-2). Thirteen items in three groups. */
export const NAV: NavItem[] = [
  { to: '/', label: '오늘', icon: House, match: ['/'], group: 0 },
  { to: '/schedule', label: '일정', icon: CalendarDays, match: ['/schedule', '/redeem/posts', '/redeem/calendar'], group: 0 },
  { to: '/review', label: '검토', icon: Inbox, match: ['/review', '/drafts'], group: 0, badge: 'review' },
  { to: '/results', label: '결과', icon: ChartColumn, match: ['/results', '/posts'], group: 0 },
  { to: '/redeem', label: '리딤', icon: Ticket, match: ['/redeem'], group: 1 },
  { to: '/affiliate', label: '쿠팡', icon: ShoppingBag, match: ['/affiliate'], group: 1 },
  { to: '/campaigns', label: '캠페인', icon: Megaphone, match: ['/campaigns'], group: 1 },
  { to: '/outreach', label: '아웃리치', icon: Handshake, match: ['/outreach'], group: 1 },
  { to: '/creators', label: '인플루언서', icon: Users, match: ['/creators'], group: 1 },
  { to: '/accounts', label: '계정', icon: AtSign, match: ['/accounts', '/targets', '/personas'], group: 2 },
  { to: '/media', label: '미디어', icon: Image, match: ['/media'], group: 2 },
  { to: '/jobs', label: '작업 기록', icon: History, match: ['/jobs'], group: 2 },
  { to: '/settings', label: '설정', icon: Settings, match: ['/settings'], group: 2 },
]

/** The phone's bottom tabs; everything else is under 더보기. */
export const TAB_PATHS = ['/', '/schedule', '/review', '/redeem']

function owns(prefix: string, pathname: string): boolean {
  if (prefix === '/') return pathname === '/'
  return pathname === prefix || pathname.startsWith(prefix + '/')
}

/** The path the menu lights up for: a detail opened from a page (the
 *  schedule's drawer, a full page on a phone) belongs to that page, so a
 *  draft opened from 일정 keeps 일정 lit; a detail reached by its address
 *  falls back to its own path. */
export function navPathname(loc: { pathname: string; state?: unknown }): string {
  const bg = (loc.state as { background?: { pathname?: unknown } } | null | undefined)?.background
  return bg && typeof bg.pathname === 'string' ? bg.pathname : loc.pathname
}

/** The item a path belongs to: the longest matching prefix wins, so
 *  /redeem/posts is 일정 and /redeem/12 is 리딤. */
export function activeNav(pathname: string): NavItem | undefined {
  let best: NavItem | undefined
  let bestLen = -1
  for (const item of NAV) {
    for (const m of item.match) {
      if (owns(m, pathname) && m.length > bestLen) {
        best = item
        bestLen = m.length
      }
    }
  }
  return best
}
